export default __webpack_public_path__ + "static/media/dashboard_assessment_report_session_icon.25daf06f.svg";